var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrophyCup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 50,
    viewBox: "0 0 41 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_4410_27685)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.2001,
    y: 25.6943,
    width: 2.50031,
    height: 7.40538,
    transform: "rotate(-0.101656 18.2001 25.6943)",
    fill: "url(#paint0_linear_4410_27685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.68593 10.0742L0.974609 10.0879C0.983523 15.1105 1.44724 17.9988 9.96729 17.9837",
    stroke: "#FFDD66",
    strokeWidth: 1.1908
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7096 16.6151C30.719 21.8684 25.6562 26.136 19.4017 26.1471C13.1472 26.1581 8.06936 21.9086 8.06004 16.6553C8.05072 11.4021 13.1134 7.1345 19.368 7.1234C25.6225 7.1123 30.7003 11.3619 30.7096 16.6151Z",
    fill: "#FFD131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4134 32.7253C14.7956 32.7335 11.0541 33.8745 11.0566 35.2737L27.7792 35.244C27.7767 33.8448 24.0312 32.7171 19.4134 32.7253Z",
    fill: "#FFD131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.03992 5.31543L30.6895 5.27524L30.7088 16.1707L8.05925 16.2108L8.03992 5.31543Z",
    fill: "#FFD131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.78 35.7329L11.0574 35.7626L11.0565 35.2292L27.7791 35.1996L27.78 35.7329Z",
    fill: "#FFD131"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.3775 10.0361L38.0889 10.0225C38.0978 15.0451 37.6443 17.935 29.1243 17.9501",
    stroke: "#DE9300",
    strokeWidth: 1.1908
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7093 16.615C30.7187 21.8682 25.6559 26.1358 19.4014 26.1469C19.4014 26.1469 19.3939 21.8883 19.3846 16.6351C19.3752 11.3818 19.3677 7.12323 19.3677 7.12323C25.6222 7.11213 30.7 11.3617 30.7093 16.615Z",
    fill: "url(#paint1_linear_4410_27685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4131 32.7252C19.4131 32.7252 19.4151 33.8594 19.4176 35.2587L27.7789 35.2438C27.7764 33.8446 24.0309 32.717 19.4131 32.7252Z",
    fill: "url(#paint2_linear_4410_27685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3644 5.29588L30.6892 5.27579L30.7086 16.1705L19.3838 16.1906L19.3644 5.29588Z",
    fill: "url(#paint3_linear_4410_27685)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7798 35.7328L19.4185 35.7476C19.4185 35.7476 19.3991 35.422 19.4175 35.2142C19.6599 32.4791 27.7788 35.1994 27.7788 35.1994L27.7798 35.7328Z",
    fill: "url(#paint4_linear_4410_27685)"
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 19.6034,
    cy: 15.5737,
    rx: 6.77714,
    ry: 5.6922,
    transform: "rotate(-0.101656 19.6034 15.5737)",
    fill: "#DCAE0C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.8061 15.4894C27.8127 19.2258 24.1922 22.3465 19.6044 22.3547C15.0167 22.3628 11.3851 19.255 11.3784 15.5186C11.3718 11.7822 14.9923 8.66151 19.5801 8.65338C24.1678 8.64524 27.7994 11.753 27.8061 15.4894Z",
    fill: "#BD8414",
    stroke: "#FFE176",
    strokeWidth: 0.602592
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.4891 10.4424L21.1395 13.4763L24.43 13.8501L22.1751 16.1924L22.7952 19.547L19.5026 18.0344L16.2154 19.5587L16.8291 16.2019L14.5604 13.8676L17.8496 13.4821L19.4891 10.4424Z",
    fill: "#FFF4BC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.6054 10.3792L19.4886 10.1646L19.3727 10.3796L17.7658 13.3587L14.545 13.7362L14.2785 13.7674L14.4655 13.9598L16.6866 16.2452L16.0853 19.5349L16.0393 19.7862L16.2711 19.6787L19.5029 18.1802L22.74 19.6672L22.9716 19.7737L22.9253 19.523L22.3176 16.2352L24.5253 13.9418L24.7111 13.7488L24.445 13.7186L21.2228 13.3526L19.6054 10.3792Z",
    stroke: "#C98500",
    strokeOpacity: 0.7,
    strokeWidth: 0.264621
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.56429 7.64636L6.75453 5.43685L5.55646 3.23158L8.18636 4.2299L10.8127 3.22226L9.62247 5.43176L10.8205 7.63703L8.19063 6.63871L5.56429 7.64636Z",
    fill: "#A7A1E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.63418 37.3504C7.63221 36.2411 8.52991 35.3402 9.63925 35.3382L29.3431 35.3033C30.4525 35.3013 31.3534 36.199 31.3553 37.3083L31.3699 45.5055L7.64872 45.5476L7.63418 37.3504Z",
    fill: "#101828"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 11.165,
    y: 38.1191,
    width: 17.1427,
    height: 4.956,
    transform: "rotate(-0.101656 11.165 38.1191)",
    fill: "#F9B50E",
    stroke: "#FFEC86",
    strokeWidth: 0.518326
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1658 37.8584L20.1553 37.8442L26.4725 43.3074L18.483 43.3215L12.1658 37.8584Z",
    fill: "#FFEC86"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6.32971,
    y: 45.5479,
    width: 26.3569,
    height: 2.1191,
    transform: "rotate(-0.101656 6.32971 45.5479)",
    fill: "#DE9300"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_4410_27685",
    x: 0.274509,
    y: 0.863132,
    width: 39.9649,
    height: 48.3676,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.725656,
    dy: 0.725656
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.414661
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4410_27685"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_4410_27685",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4410_27685",
    x1: 19.4502,
    y1: 25.6943,
    x2: 19.4502,
    y2: 33.0997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C07F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE9300"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4410_27685",
    x1: 30.6283,
    y1: 14.8681,
    x2: 19.2748,
    y2: 14.8882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE8A04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4410_27685",
    x1: 30.6283,
    y1: 14.8681,
    x2: 19.2748,
    y2: 14.8882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE8A04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4410_27685",
    x1: 30.6283,
    y1: 14.8681,
    x2: 19.2748,
    y2: 14.8882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE8A04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC11"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4410_27685",
    x1: 30.6283,
    y1: 14.8681,
    x2: 19.2748,
    y2: 14.8882,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CE8A04"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFBC11"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrophyCup);
export default __webpack_public_path__ + "static/media/TrophyCup.21218aca281d3e31eb136ac3686ecc12.svg";
export { ForwardRef as ReactComponent };